// Theme Presets

const lightTheme = {
  name: "light",
  body: "#F3F4F6",
  text: "#0F172A",
  dark: "#000000",
  secondaryText: "#6B7280",
  accentColor: "#2563EB",
  accentBright: "#0EA5E9",
  projectCard: "#FFFFFF",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#E5E7EB",
  imageClothes: "#E5E7EB",
  avatarMisc: "#F3F4F6",
  avatarShoes: "#D1D5DB",
  gradient: "linear-gradient(135deg, #1d4ed8 0%, #0ea5e9 100%)",
  cardBg: "rgba(255, 255, 255, 0.9)",
  shadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
};

const darkTheme = {
  name: "dark",
  body: "#020617",
  text: "#E5E7EB",
  dark: "#000000",
  secondaryText: "#9CA3AF",
  accentColor: "#60A5FA",
  accentBright: "#38BDF8",
  projectCard: "#020617",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#020617",
  imageClothes: "#0B1120",
  avatarMisc: "#020617",
  avatarShoes: "#020617",
  gradient: "linear-gradient(135deg, #1d4ed8 0%, #0ea5e9 100%)",
  cardBg: "rgba(15, 23, 42, 0.95)",
  shadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
};

export const themes = { light: lightTheme, dark: darkTheme };
